<template>
  <div class="doctorDetail">
    <div class="personInfo">
      <img class="avatar" :src="doctorDetail.imgUuid" alt="">
      <div class="info">
        <p class="name" @click.prevent="handleClick">{{doctorDetail.name}}</p>
        <p class="rank">{{doctorDetail.level}}</p>
        <p class="num">接诊量：{{doctorDetail.orderCount}}</p>
        <p class="good">擅长：{{doctorDetail.baseInfo}}</p>
      </div>
    </div>
    <div class="content">
      <h4>医生简介</h4>
      <p class="intro" v-html="doctorDetail.introduction"></p>
      <table>
        <tbody>
        <tr>
          <th colspan="2">坐诊日期</th>
          <th>诊别</th>
          <th>诊金（元）</th>
          <th>服务费（元）</th>
        </tr>
          <tr v-for="(item, index) in doctorPriceDtos" :key="index">
            <td class="time" :rowspan="JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? 0 : 2" v-if="JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? false : true">{{week(item.week)}}</td>
            <td>{{JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? '下午' : '上午'}}</td>
            <td>{{JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? item.pmremarks : item.amremarks}}</td>
            <td>{{JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? item.pmprice : item.amprice}}</td>
            <td>{{JSON.stringify(item).indexOf(JSON.stringify(item['amprice'])) == -1 ? item.pmserviceFee : item.amserviceFee}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {reqDoctorDetail} from '../../../../api'
export default {
  data() {
    return {
      doctorDetail: {},
      doctorPriceDtos: []
    }
  },
  created() {
    const {id} = this.$route.query
    reqDoctorDetail(id).then(res => {
      if(res.code === 200){
        this.doctorDetail = res.data.bussData
        res.data.bussData.doctorPriceDtos.forEach((item, index) => {
          let am = {amprice:item.amprice, amremarks:item.amremarks, amserviceFee:item.amserviceFee, doctorid:item.doctorid, createtime:item.createtime, id:item.id, week:item.week}
          let pm = {pmprice:item.pmprice, pmremarks:item.pmremarks, pmserviceFee:item.pmserviceFee, doctorid:item.doctorid, createtime:item.createtime, id:item.id, week:item.week}
          this.doctorPriceDtos.push(am)
          this.doctorPriceDtos.push(pm)
          let objectArraySort = function (keyName) {
            return function (objectN, objectM) {
              let valueN = objectN[keyName]
              let valueM = objectM[keyName]
              if (valueN < valueM) return -1
              else if (valueN > valueM) return 1
              else return 0
            }
          }
          this.doctorPriceDtos.sort(objectArraySort('week'))
        })
      }
    })
  },
  methods: {
    week(week){
      console.log(week)
      switch (week) {
        case 0:
          return '星期日'
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
      }
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.doctorDetail{
  float: left;
  width: 1020px;
  margin-bottom: 46px;
  .personInfo{
    display: flex;
    width: 480px;
    height: 220px;
    padding:20px;
    box-sizing: border-box;
    box-shadow:0px 3px 9px 0px rgba(0, 0, 0, 0.09);
    .avatar{
      display: block;
      width: 180px;
      height: 180px;
      margin-right: 20px;
      background: #ccc;
    }
    .info{
      width: 240px;
      .name{
        margin-bottom: 12px;
        font-size: 18px;
        font-weight: bold;
        font-family:PingFang-SC-Bold;
      }
      .rank{
        margin-bottom: 17px;
        color:#61aee6;
      }
      .num{
        margin-bottom: 15px;
      }
      .good{
        height: 84px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
      }
    }
  }
  .content{
    color:#000;
    h4{
      margin-top:20px;
    }
    .intro{
      width: 482px;
      margin-top:13px;
      line-height: 24px;
    }
    table{
      width: 625px;
      margin-top:38px;
      text-align: center;
      line-height: 40px;
      th,td{
        border:1px solid #999;
        vertical-align: middle;
      }
      td{
        &.time{
          background: #fff;
        }
      }
      tr:nth-of-type(2n){
        background: #f6f6f6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Children/Hospital/DoctorDetail.vue